import { overlay } from 'overlay-kit';
import type { ReactNode } from 'react';

import {
  GlobalConfirmPopup,
  type GlobalConfirmButtonOptions,
} from '@/shared/components/global-confirm-popup';

export type GlobalConfirmPopupAction = 'confirm' | 'cancel';

interface RequestGlobalConfirmPopupParams {
  title: ReactNode;
  description: ReactNode;
  onConfirm: () => void | Promise<void>;
  confirmButton?: GlobalConfirmButtonOptions;
  cancelText?: ReactNode;
}

export function requestConfirm({
  title,
  description,
  onConfirm,
  confirmButton,
  cancelText,
}: RequestGlobalConfirmPopupParams): Promise<void> {
  return overlay.openAsync(({ isOpen, close, unmount }) => {
    return (
      <GlobalConfirmPopup
        isOpen={isOpen}
        title={title}
        description={description}
        cancelText={cancelText}
        confirmButton={confirmButton}
        onConfirm={async () => {
          await onConfirm();
        }}
        onUnmount={unmount}
        onConfirmSuccess={close}
        onCancel={close}
      />
    );
  });
}
